export default "__VITE_ASSET__Bk09Z44D__"